import './App.css';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/header/navbar';
import { Box } from '@mui/material';
import Footer from './components/footer/footer';
import BranchesSearch from './page/branches-search';

export default function App() {
  return (
    <>
      <Box
        sx={{
          width: '100%',
          zIndex: 2000,
          backgroundColor: '#0d7f42',
        }}>
        <Navbar />
      </Box>

      <main>
        <Routes>
          <Route path="/" element={<BranchesSearch />}></Route>
        </Routes>
      </main>

      <Box
        sx={{
          width: '100%',
          color: '#FFFFFF',
          zIndex: 2000,
          backgroundColor: '#0d7f42',
        }}>
        <Footer />
      </Box>
    </>
  );
}
